import React, { memo } from "react";
import Skeleton from "@mui/material/Skeleton";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "components/ui";

const ControlSkeleton = ({ control }) => {
  if (control === "switch") {
    return (
      <Skeleton
        variant="rounded"
        width={44}
        height={20}
        sx={{ borderRadius: "999px" }}
      />
    );
  }

  if (control === "buttons") {
    return <Skeleton variant="rounded" width={120} height={36} />;
  }

  return <Skeleton variant="rounded" width="100%" height={40} />;
};

export const FieldRowSkeleton = ({ control = "input" }) => {
  return (
    <div
      className={`flex ${
        control === "switch" ? "py-1 justify-between " : ""
      }items-center flex-wrap lg:flex-nowrap gap-2.5`}
    >
      <div className="flex w-full max-w-56">
        <Skeleton variant="text" width={150} height={24} />
      </div>
      <ControlSkeleton control={control} />
    </div>
  );
};

export const FooterButtonSkeleton = () => {
  return (
    <CardFooter className="justify-end">
      <Skeleton
        variant="rounded"
        width={96}
        height={40}
        sx={{ borderRadius: "6px" }}
      />
    </CardFooter>
  );
};

const SettingCardSkeleton = memo(
  ({
    titleWidth = 140,
    controls = [],
    showFooter = false,
    className = "min-w-full",
  }) => {
    return (
      <Card className={className}>
        <CardHeader>
          <Skeleton variant="text" width={titleWidth} height={32} />
        </CardHeader>

        <CardContent className="grid gap-5">
          {controls.map((control, index) => (
            <FieldRowSkeleton key={index} control={control} />
          ))}
        </CardContent>

        {showFooter && <FooterButtonSkeleton />}
      </Card>
    );
  },
);

SettingCardSkeleton.displayName = "SettingCardSkeleton";

export default SettingCardSkeleton;
